<template>
<div id="app" class="site container hfeed" style="height: auto !important">
  <HeadNav selectedLanguage="en" page="disclaimer" />
  <div id="content" class="site-content" style="height: auto !important">
    <article id="article" class="center" style="height: auto !important">
      <section class="page-content">
        <h1>Disclaimer</h1>
        <h2>General Information</h2>
        <p>GBWhatsApp is not affiliated with WhatsApp Inc. or any other official messaging services. All trademarks, registered trademarks, and product names are the property of their respective owners.</p>
        <h2>No Warranty</h2>
        <p>The information provided on this website is for general informational purposes only. We make no representations or warranties of any kind.</p>
        <h2>Third-Party Links</h2>
        <p>Our website may contain links to third-party websites. We have no control over the content of these sites.</p>
        <h2>Limitation of Liability</h2>
        <p>We will not be liable for any damages arising from the use of our website or downloading any files.</p>
      </section>
    </article>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  components: { HeadNav },
};
</script>

<style lang="scss" scoped>
.page-content {
  max-width: 1080px;
  margin: 2rem auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  h1 { color: #25D366; font-size: 2.5em; margin-bottom: 30px; }
  h2 { color: #25D366; font-size: 1.8em; margin: 30px 0 20px; }
  p { line-height: 1.8; font-size: 16px; color: #444; word-break: break-word; }
}

@media (max-width: 768px) {
  .page-content {
    padding: 20px 15px;
    h1 { font-size: 2em; }
    h2 { font-size: 1.4em; }
    p { font-size: 15px; }
  }
}
</style>
